//
export const canDisplayBulkActionsConsole = () => Userdata.Permissions.bulk_action_max_size > 0

export default canDisplayBulkActionsConsole
